import React, { useEffect, useState } from 'react'
import { faFileExcel, faInfo } from '@fortawesome/free-solid-svg-icons'
import TableComp from '../../components/Table'
import PaginationComp from '../../components/Pagination'
import CustomTitle from '../../components/CustomTitle'
import ButtonIcon from '../../components/ButtonComp'
import useOfflineDevices from 'hooks/useOfflineDevices'
import FiltersComp from './Filters'
import useForm from 'hooks/useForm'
import DownloadXLSX from './Download'
import CustomLayout from 'components/Layout'

const AlarmManagement: React.FC = () => {
    const [queryParams, setQueryParams] = useState({ deviceType: 'all', startDate: '', endDate: '' });
    const hookForm = useForm<Record<string, any>>({ device_type: 'all', startDate: '', endDate: '' });
    const { deviceType } = hookForm.params
    const hookOfflineDevices = useOfflineDevices({ orderBy: "desc", pageSize: 10, page: 1, ...queryParams });
    const [modalXlsx, setModalXlsx] = useState<boolean>(false);

    useEffect(() => {
        setQueryParams({
            deviceType: deviceType === 'all' ? undefined : deviceType,
            startDate: hookForm.form?.startDate,
            endDate: hookForm.form?.endDate,
        });
    }, [hookForm.params]);

    return (
        <CustomLayout>
            <CustomTitle
                title='Gestión de Alarmas'
                actions={[
                    <ButtonIcon key='key-download' icon={faFileExcel} tooltip='Descargar archivo' variant='outline-success' onClick={() => setModalXlsx(true)} />,
                    <FiltersComp hookForm={hookForm} />,
                ]}
            />
            <TableComp
                headers={['#', 'ID', 'Dispositivo', 'Elemento', 'Estado', 'Fecha de Desconexión', 'Acciones']}
                keys={['#', 'id', 'device_type', 'description', 'is_online', 'created_at']}
                body={hookOfflineDevices.data}
                actions={[{ icon: faInfo, handleClick: () => { }, tooltip: "Ver detalles", variant: "outline-primary" }]}
                moment_dates={[{ index: 5, format: "LLL" }]}
                page={hookOfflineDevices.page}
                loadingItems={hookOfflineDevices.pageSize}
                loading={hookOfflineDevices.loading}
                badges={[{ index: 2 }, { index: 4 }]}
                badges_values={[
                    {
                        col: 'device_type', values: [
                            { name: 'Estación Meteorológica', value: 'weather_station', color: '#008080' },
                            { name: 'Cámara CCTV', value: 'cctv', color: '#7d3c98' },
                            { name: 'Panel de Mensaje Variable', value: 'pmv', color: '#e67e22' }
                        ]
                    },
                    { col: 'is_online', values: [{ name: 'Desconectado', value: 'false', color: '#C70039' }, { name: 'Conectado', value: true, color: '#008000' }] }
                ]}
            />
            <PaginationComp
                onChange={hookOfflineDevices.changePage}
                page={hookOfflineDevices.page}
                defaultPageSize={hookOfflineDevices.pageSize}
                totalItems={hookOfflineDevices.totalItems}
            />
            {/* Modal para descargar xlsx */}
            {
                modalXlsx && <DownloadXLSX onClose={() => setModalXlsx(false)} />
            }

        </CustomLayout>
    )
}

export default AlarmManagement